module.exports = __webpack_public_path__ + "img/drawer.79942c13.jpg";